import React from 'react';
import PropTypes from 'prop-types';
import SurveyCounters from 'components/app/reports/components/SurveyCounters';
import SurveyResponsesPdf from 'components/app/reports/components/SurveyResponsesPdf';
import ResponsesTablePdf from 'components/app/reports/components/ResponsesTablePdf';

const DashboardPrint = ({ surveyId, surveyName, refreshKey }) => (
  <div style={{ padding: 24 }}>
    <h2 style={{ textAlign: 'center', marginBottom: 24 }}>{surveyName}</h2>
    <SurveyCounters
      surveyId={surveyId}
      key={`counters-${surveyId}-${refreshKey}`}
    />
    <SurveyResponsesPdf
      surveyId={surveyId}
      key={`openresponses-${surveyId}-${refreshKey}`}
    />
    <ResponsesTablePdf
      surveyId={surveyId}
      key={`responses-${surveyId}-${refreshKey}`}
    />
  </div>
);

DashboardPrint.propTypes = {
  surveyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  surveyName: PropTypes.string,
  refreshKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

ResponsesTablePdf.propTypes = {
  surveyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default DashboardPrint;
